import { createContext } from 'react';
import OrderPageStore from './orderPageStore';

const OrderPageStoreContext = createContext(new OrderPageStore());

export default OrderPageStoreContext;
